// @flow
import prebookSearchTripBuilder from './prebookSearchTrip'

// Types
import type { Trip } from '../../../models/trip'
import type { PrebookSearchResponse } from '../../../api_types'

export type PlainSearchResponse = {
  results: Array<Trip>,
  searchId: string,
  createdAt: number,
  expiresAt: number,
  expiresIn: number,
}

/**
 * Build each trip separately and just return a list of trips without any
 * organization of the trips with the categories, etc.
 * @param  {PrebookSearchResponse} response
 * @return {PlainSearchResponse}
 */
export function plainSearchResultBuilder(
  response: PrebookSearchResponse
): PlainSearchResponse {
  const tripList = response.results.map((trip) =>
    prebookSearchTripBuilder(trip, response)
  )

  return {
    results: tripList,
    searchId: response.search_id,
    createdAt: response.created_at,
    expiresAt: response.expires_at,
    expiresIn: response.expires_in,
  }
}

export default plainSearchResultBuilder
